import PropTypes from 'prop-types';
import React from 'react';

export default function TextWithTitle({ text, ...props }) {
    return <span title={text} {...props}>{text}</span>;
}

TextWithTitle.propTypes = {
    text: PropTypes.node,
};
